import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

const permitTypes = [
  { key: 'new', description: 'New' },
  { key: 'renewal', description: 'Renewal' },
  { key: 'for_planning', description: 'Planning Dept.' },
  { key: 'for_engineering', description: 'Engr. Dept.' },
]

function RequirementsTagging({
  getRequirementList, requirementList, 
  getSettingsList, settingsList,
  fetchRequirementsList, ebplsRequirementsList,
  updateApplicationRequirements,
}) {
  const [requirementListFormat, setRequirementListFormat] = useState([]);
  const [permitTypeListFormat, setPermitTypeListFormat] = useState([]);
  const [mode, setMode] = useState(0);
  const [formData, setFormData] = useState([]);

  const updateData = () => {
    getRequirementList({ display_all: 1 });
    getSettingsList()
    fetchRequirementsList();
  };

  const formatFormData = () => {
    if (!_.isEmpty(ebplsRequirementsList)) {
      const list = ebplsRequirementsList.map((item) => {
        return item.attributes 
      })
      setPermitTypeListFormat(list);
      setFormData(list);
    }
  };
  const handleSetMode = (num) => {
    setMode(num);
  };

  const handleToggle = (parseType, permitKey, reqId) => () => {
    handleSetMode(1);
    const item = formData?.filter(x => (x.requirement_id === +reqId));
    const status = item.find(x => (parseType !== '' ? x.application_status_id === parseType : x[permitKey] === 1));
    const valueAction = () => {
      if (_.isEmpty(status) && parseType !== '') {
        const a = _.concat(
          item.filter(x => (x.requirement_id === +reqId)),
          {
            requirement_id: +reqId,
            application_status_id: parseType,
            for_planning: 0,
            for_engineering: 0,
          }
        );
        return a
      }
      if (parseType === '') {
        return item.map((x) => {
          return { ...x, [permitKey]: x[permitKey] === 1 ? 0 : 1}
        });
      }
      const a = item.filter(x => (x.requirement_id === +reqId && x.application_status_id !== parseType));
      return a;
    };

    const newItem = valueAction()

    const reducedFormData = formData.filter(x => (+x.requirement_id !== +reqId)); // REMOVE TARGET FROM FORMDATA
    const newFormData = _.concat(reducedFormData, newItem);
    setFormData(newFormData);
  };

  const renderCheckbox = (permitKey, reqId) => {
    const parseType = () => {
      if(permitKey === 'new') return Number(settingsList[0]?.id || 2);
      if(permitKey === 'renewal') return Number(settingsList[1]?.id || 3);
      return ''
    }
    const item = formData?.filter(x => (+x.requirement_id === +reqId));
    const status = item.find(x => (parseType() !== '' ? x.application_status_id === parseType() : x[permitKey] === 1))
    return (
      <button type="button" className="btn-blank" onClick={handleToggle(parseType(), permitKey, reqId)}>
        {_.isEmpty(status)
          ? (<i className="far fa-square icon-check-box" />)
          : (<i className="fas fa-check-square icon-box" />)}
      </button>
    );
  };

  const handleSubmit = () => {
    handleSetMode(0);
    updateApplicationRequirements({ requirements: formData })
  };

  const handleCancel = () => {
    setFormData(permitTypeListFormat);
    handleSetMode(0);
  };

  useEffect(() => {
    updateData();
  }, []);

  useEffect(() => {
    formatFormData();
  }, [ebplsRequirementsList]);

  useEffect(() => {
    if (!_.isEmpty(requirementList)) {
      const list = requirementList.map(x => ({
        requirement_id: _.get(x, 'id', ''),
        requirement_name: _.get(x, 'attributes.name'),
      }));
      setRequirementListFormat(list);
    }
  }, [requirementList]);

  return (
    <div className="card p-0">
      <div className="card-content-listing">
        <div className="container-fluid p-0">
          <div className="row d-flex align-items-center">
            <div className="col-6">
              <h3>Requirements Tagging</h3>
            </div>
            <div className="col-6 d-flex">
              {mode === 1 ? (
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold ml-auto px-4 mr-1"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-round font-weight-bold px-4"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </React.Fragment>
              ) : ''
              }
            </div>
          </div>
          {/* TABLE */}
          <div className="table-responsive mt-4">
            <table className="table table-borderless">
              <thead>
                <tr>
                  {!_.isEmpty(permitTypes)
                    ? (
                      <React.Fragment>
                        <th scope="col" className="px-1">Requirement Types</th>
                        {permitTypes.map(item => (
                          <th scope="col" className="px-1" key={item.key}><div className="w-100 text-center">{item.description || ''}</div></th>
                        ))}
                      </React.Fragment>
                    ) : <th scope="col">Requirement Types</th>}
                </tr>
              </thead>
              <tbody>
                {!_.isEmpty(requirementListFormat)
                  ? (
                    <React.Fragment>
                      {requirementListFormat.map(item => (
                        <tr className="top-border" key={item.requirement_id}>
                          <td className="font-weight-bold py-3">{item.requirement_name}</td>
                          {permitTypes.map(x => (
                            <td className="py-3" key={x.key}><div className="w-100 text-center">{renderCheckbox(x.key, item.requirement_id)}</div></td>
                          ))}
                          {/* <td className="py-3" key={x.id}><div className="w-100 text-center">{renderCheckbox(x.id, item.requirement_id)}</div></td> */}
                        </tr>
                      ))}
                    </React.Fragment>
                  ) : <tr />}
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

RequirementsTagging.propTypes = {  
  fetchRequirementsList: PropTypes.instanceOf(Function).isRequired,
  ebplsRequirementsList: PropTypes.instanceOf(Array).isRequired,

  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  requirementList: PropTypes.instanceOf(Array).isRequired,

  getSettingsList: PropTypes.instanceOf(Function).isRequired,
  settingsList: PropTypes.instanceOf(Array).isRequired,

  updateApplicationRequirements: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  ebplsRequirementsList: _.get(api, `${c.FETCH_REQUIREMENTS_LIST}.list`) || [],
  requirementList: _.get(api, `${c.GET_REQUIREMENT_LIST}.list`) || [],
  settingsList: _.get(api, `${c.GET_SETTINGS}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);

export default enhance(RequirementsTagging);
